import { Filters } from 'context/FilterProvider/types/Filters';

export const areFiltersDefault = (filters: Filters): boolean => {
  return Object.values(filters).every(
    (filterArray) => Array.isArray(filterArray) && filterArray.length === 0
  );
};
